import type { RevenuePaymentStatus } from "./types/revenue.types";

/**
 * The pill each state wears, shared by the table's rows and the phone's cards
 * so a payment reads the same whichever of the two is drawn.
 *
 * No border on these: they sit inside a row or a card, not beside a page
 * heading.
 */
export const PAYMENT_STATUS_STYLES: Record<RevenuePaymentStatus, string> = {
  Paid: "bg-[#E7F8EF] text-[#2F8E5B]",
  Pending: "bg-[#FDF0DC] text-[#B4761A]",
  Cancelled: "bg-[#F1F4F6] text-ink-muted",
};

/** The pill itself, minus its colours. */
export const PAYMENT_STATUS_PILL =
  "inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-[12px] font-medium";
